namespace app.support {
    "use strict";

    export interface Error {
        internalCode: string;
        userMessage: string;
        moreDetails: string;
        targetName: string;
    }

    export interface ApiError {
        httpCode: number;
        errors: Error[];
    }

    /**
     * Serviço para abstrair o formato do json
     * que é retornado do backend quando ocorrer
     * um erro. Esse serviço conhece o formato desses
     * objetos e conseguirá extrair informações deles.
     */
    export class ErrorService {
        
        public buildErrorMessages(apiError): string[] {
            if (this.isApiError(apiError)) {
                let checkedApiError: ApiError = <ApiError>apiError;
                return checkedApiError.errors.map((error) => {
                    if (this.isError(error)) {
                        return error.userMessage;
                    } else {
                        throw "Formato de erro não reconhecido";
                    }
                });
            } else if (angular.isString(apiError)) {
                return apiError;
            } else {
                throw "Formato de erro de API não reconhecido";
            }
        }

        public isApiError(possibleApiError): boolean {
            if (possibleApiError && 
                    possibleApiError.httpCode &&
                    possibleApiError.errors &&
                    possibleApiError.errors.length > 0) {
                return true;
            } else {
                return false;
            }
        }

        public isError(possibleError): boolean {
            if (possibleError && 
                    possibleError.internalCode &&
                    possibleError.userMessage) {
                return true;
            } else {
                return false;
            }
        }

    }
    
    angular
            .module("app.support")
            .service("errorService", ErrorService);
    
}